/**
 * Persists the last successful LoginPortal email on the Gateway origin.
 * Tenant redirects cannot read this value, but the portal can prefill it on
 * the next Tiger login.
 */

export const LAST_LOGIN_EMAIL_KEY = 'wms_last_login_email';

export function getLastLoginEmail() {
  if (typeof window === 'undefined') return '';
  try {
    return window.localStorage.getItem(LAST_LOGIN_EMAIL_KEY)?.trim() || '';
  } catch {
    return '';
  }
}

export function persistLastLoginEmail(email) {
  if (typeof window === 'undefined') return;
  const value = String(email ?? '').trim();
  if (!value) return;
  try {
    window.localStorage.setItem(LAST_LOGIN_EMAIL_KEY, value);
  } catch {
    /* quota / private mode */
  }
}
